export default {
  max12: {
    lg: 1.5,
    md: 3,
    sm: 4,
    xs: 12
  },
  max6: {
    lg: 2,
    md: 3,
    sm: 4,
    xs: 12
  },
  max4: {
    lg: 3,
    sm: 6,
    xs: 12
  },
  max3: {
    lg: 4,
    md: 12,
    sm: 12,
    xs: 12
  },
  max2: {
    lg: 6,
    md: 6,
    sm: 12,
    xs: 12
  }
}



// WEBPACK FOOTER //
// ./src/styles/columns/index.js